// extracted by mini-css-extract-plugin
export default {"body":"signin_body__KQogU"};